import { faLock, faEye } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Divider,
  IconWrapper,
  IndicatorContainer,
  IndicatorText,
  TextContent,
} from './message-visibility-indicator.styles';

export type TMessageVisibilityIndicatorProps = {
  isPrivate: boolean;
  recipientNames?: string[];
};

export const MessageVisibilityIndicator = ({
  isPrivate = false,
  recipientNames,
}: TMessageVisibilityIndicatorProps) => {
  const getIndicatorText = () => {
    if (isPrivate) {
      if (recipientNames && recipientNames.length > 0) {
        const namesText = recipientNames.join(' and ');
        return `Private • Only visible to you and ${namesText}`;
      }
      return 'Private • Only visible to you';
    }
    return 'Visible to everyone';
  };

  return (
    <IndicatorContainer
      $isPrivate={isPrivate}
      data-cy="message-visibility-indicator"
    >
      <Divider />
      <TextContent data-cy="message-visibility-indicator-content">
        <IconWrapper $isPrivate={isPrivate}>
          <FontAwesomeIcon icon={isPrivate ? faLock : faEye} />
        </IconWrapper>
        <IndicatorText
          $isPrivate={isPrivate}
          data-cy="message-visibility-indicator-text"
        >
          {getIndicatorText()}
        </IndicatorText>
      </TextContent>
      <Divider />
    </IndicatorContainer>
  );
};

export default MessageVisibilityIndicator;
